import { render, staticRenderFns } from "./Thresholds.vue?vue&type=template&id=067a23a8"
import script from "./Thresholds.vue?vue&type=script&lang=js"
export * from "./Thresholds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports